import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import FormControlLabel from '@mui/material/FormControlLabel';
import IconButton from '@mui/material/IconButton';
import Radio from '@mui/material/Radio';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
import SimpleBar from 'simplebar-react';
import BtnGradient from 'src/components/common/button/BtnGradient';
import BtnOutlineGradient from 'src/components/common/button/BtnOutlineGradient';
import PatientInfo from 'src/components/common/PatientInfo';

const patient = {
  id: 1094,
  patientno: '0000001',
  fullname: 'テスト1094',
  kana: 'テスト1094',
  oldname: '',
  oldkana: '',
  salon_no: '',
  dob: '1984/09/06',
  gender: 3,
  gender2: 4,
  email: 'h.amemiya@kyimage.com',
  username: 'h.amemiya@kyimage.com',
  password: '083b707ff6b42e83ba0cc2610da5ee34',
  facilityid: 1,
  phone1:
    '0300000000/090-0000-0000/090-0000-0000/090-0000-0000/090-0000-0000/090-0000-0000/090-0000-0000',
  phone2: '090-0000-0000',
  postcode: '100-0001',
  prefecture: 13,
  address: '東京都港区赤坂１－１－１',
  note: 'XXX感染症をお持ちです\n',
  tagflag: null,
  tagby: null,
  status: 1,
  inputtime: '2022-03-01 00:00:00',
  updatetime: '2024-10-31 13:48:30',
  icons: [
    {
      piconid: 1,
      codename: '',
      namej: '♡',
      activecolor: '#FE0000',
      status: 1,
      note: '対応注意',
      colorcode: '#FE0000',
      active: 1,
    },
    {
      piconid: 2,
      codename: '',
      namej: '☆',
      activecolor: '#92D14F',
      status: 1,
      note: 'K(細かい)・心配性',
      colorcode: '#92D14F',
      active: 1,
    },
    {
      piconid: 3,
      codename: '',
      namej: '◇',
      activecolor: '#FFC000',
      status: 1,
      note: 'LINE登録有',
      colorcode: '#F2F2F2',
      active: 0,
    },
    {
      piconid: 4,
      codename: '',
      namej: '⚠',
      activecolor: '#0170C2',
      status: 1,
      note: '既往歴・服用中の薬注意・診断書ありなどNSさんが気を付けること',
      colorcode: '#0170C2',
      active: 1,
    },
    {
      piconid: 5,
      codename: '',
      namej: '后',
      activecolor: '#808080',
      status: 1,
      note: '后相',
      colorcode: '#F2F2F2',
      active: 0,
    },
    {
      piconid: 6,
      codename: '',
      namej: '禁',
      activecolor: '#808080',
      status: 1,
      note: '予約禁',
      colorcode: '#F2F2F2',
      active: 0,
    },
    {
      piconid: 7,
      codename: 'assignment',
      namej: 'assignment',
      activecolor: '#FFC000',
      status: 1,
      note: 'メモ欄要チェック',
      colorcode: '#F2F2F2',
      active: 0,
    },
  ],
  private_note: '',
  vip: false,
  lastlogin: '2024-10-31 13:48:34',
  type: 1,
  commonid: 'google-oauth2|112076792463156368464',
  lineid: null,
  alert: '',
  dobj: '昭和59年09月06日',
  dobj_short: 'S59.09.06',
  age: '40歳',
  age_num: 40,
  birthagemonthgender: '1984-09-06 40歳1ヶ月 女',
  gendertext: 'その他（MTF）',
  phone:
    '0300000000/090-0000-0000/090-0000-0000/090-0000-0000/090-0000-0000/090-0000-0000/090-0000-0000/090-0000-0000',
  rankinfo: {
    rank: 0,
    rank_start: '',
    rank_end: '',
    discount: 0,
    colorcode: '',
  },
  bgcolor: '#EC7063',
  groups: [
    {
      id: 1,
      name: '管理職権限',
      users: '河内, 山口先生, 朱, 山口雅博, 松浦先生, 奥田, 雨宮洋輝',
    },
  ],
  privacies: [],
  privacy: 0,
  lockable: 0,
  notes: [
    {
      label: 'アレルギー・既往歴',
      items: [
        {
          label: 'アレルギー・既往歴',
          value: '',
          code: 'allergy',
          type: 'text',
        },
      ],
      empty: 1,
    },
    {
      label: 'CT情報',
      type: 'text',
      items: [
        {
          label: '受け取り',
          value: '',
          code: 'ct_get',
          type: 'radio',
          options: [
            {
              value: 'あり',
              label: 'あり',
            },
            {
              value: 'なし',
              label: 'なし',
            },
          ],
        },
        {
          label: '神経',
          value: '',
          code: 'ct_nerve',
          type: 'radio',
          options: [
            {
              value: 'OK',
              label: 'OK',
            },
            {
              value: 'NG',
              label: 'NG',
            },
          ],
        },
        {
          label: '返却',
          value: '',
          code: 'ct_return',
          type: 'radio',
          options: [
            {
              value: 'した',
              label: 'した',
            },
            {
              value: 'してない',
              label: 'してない',
            },
          ],
        },
        {
          label: 'メモ',
          value: '',
          code: 'ct_memo',
          type: 'text',
        },
      ],
      empty: 1,
    },
    {
      label: 'VISIAの撮影履歴',
      items: [
        {
          label: '日付',
          value: '',
          code: 'visia_date',
          type: 'date',
        },
        {
          label: '担当者',
          value: '',
          code: 'person',
          type: 'select',
          options: [],
        },
      ],
      empty: 1,
    },
    {
      label: '家族・友人情報',
      items: [
        {
          label: 'ID 患者名',
          value: '',
          code: 'patient',
          type: 'select',
          options: [],
        },
        {
          label: '関係性',
          value: '',
          code: 'relation',
          type: 'text',
        },
      ],
      empty: 1,
    },
    {
      label: '対応注意・予約NGの理由',
      items: [
        {
          label: '対応注意・予約NGの理由',
          value: '',
          code: 'ng_reason',
          type: 'text',
        },
      ],
      empty: 1,
    },
    {
      label: '備考',
      items: [
        {
          label: '備考',
          value: '',
          code: 'note',
          type: 'text',
        },
      ],
      empty: 1,
    },
  ],
};

interface DialogCompareProps {
  open: boolean;
  // id: number;
  onClose: () => void;
  handleIntegrate: () => void;
  handleNotDuplicate: () => void;
}

const DialogCompare: React.FC<DialogCompareProps> = (props) => {
  const [selectedValue, setSelectedValue] = useState('a');

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedValue(event.target.value);
  };
  const handleClose = () => {
    props.onClose();
  };

  return (
    <Dialog
      open={props.open}
      onClose={handleClose}
      sx={{
        '& .MuiDialog-paper': {
          width: '100%',
          minWidth: '1000px',
          m: '0px',
        },
      }}
    >
      <DialogTitle
        id='scroll-dialog-title'
        sx={{ p: '10px 20px', borderBottom: '1px solid #E6E9ED' }}
      >
        <Stack
          direction={'row'}
          justifyContent={'space-between'}
          alignItems={'center'}
        >
          <Typography
            sx={{ fontSize: '20px', lineHeight: '24px', fontWeight: 500 }}
          >
            患者情報を比較
          </Typography>
          <IconButton aria-label='Close' edge='end' onClick={handleClose}>
            <Box
              component={'img'}
              src='/images/ic-close-blue.svg'
              alt='icon eye'
              sx={{ width: '24px', height: '24px' }}
            />
          </IconButton>
        </Stack>
      </DialogTitle>

      <DialogContent
        sx={{
          p: '0',
          '& .simplebar-track.simplebar-vertical .simplebar-scrollbar:before': {
            backgroundColor: '#CCD1D9',
          },
          overflow: 'hidden',
        }}
      >
        <Stack direction={'row'} spacing={'8px'}>
          <Stack flex={1} p={'20px'}>
            <SimpleBar
              style={{ height: 'calc(100vh - 180px)', borderWidth: '18px' }}
            >
              <Stack spacing='15px' sx={{ pr: '14px', mt: '20px' }}>
                <FormControlLabel
                  control={
                    <Radio
                      checked={selectedValue === 'a'}
                      onChange={handleChange}
                      value='a'
                      name='patient_id'
                      inputProps={{ 'aria-label': 'A' }}
                    />
                  }
                  label='このIDを優先する'
                />
                <PatientInfo patient={patient} />
              </Stack>
            </SimpleBar>
          </Stack>
          <Stack flex={1} p={'20px'} borderLeft={'1px solid #F3F3F3'}>
            <SimpleBar
              style={{ height: 'calc(100vh - 180px)', borderWidth: '18px' }}
            >
              <Stack spacing='15px' sx={{ pr: '14px', mt: '20px' }}>
                <FormControlLabel
                  control={
                    <Radio
                      checked={selectedValue === 'b'}
                      onChange={handleChange}
                      value='b'
                      name='patient_id'
                      inputProps={{ 'aria-label': 'B' }}
                    />
                  }
                  label='このIDを優先する'
                />
                <PatientInfo patient={patient} />
              </Stack>
            </SimpleBar>
          </Stack>
          <Stack flex={1} p={'20px'} borderLeft={'1px solid #F3F3F3'}>
            <SimpleBar
              style={{ height: 'calc(100vh - 180px)', borderWidth: '18px' }}
            >
              <Stack spacing='15px' sx={{ pr: '14px', mt: '20px' }}>
                <FormControlLabel
                  control={
                    <Radio
                      checked={selectedValue === 'c'}
                      onChange={handleChange}
                      value='c'
                      name='patient_id'
                      inputProps={{ 'aria-label': 'C' }}
                    />
                  }
                  label='このIDを優先する'
                />
                <PatientInfo patient={patient} />
              </Stack>
            </SimpleBar>
          </Stack>
        </Stack>
      </DialogContent>

      <DialogActions
        style={{
          justifyContent: 'right',
          padding: '16px',
        }}
      >
        <BtnOutlineGradient text='キャンセル' handleButtonClick={handleClose} />
        <BtnGradient
          text='重複ではない'
          handleButtonClick={() => props.handleNotDuplicate()}
          width='100px'
        />
        <BtnGradient
          text='統合する'
          handleButtonClick={() => props.handleIntegrate()}
        />
      </DialogActions>
    </Dialog>
  );
};
export default DialogCompare;
